import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-saml',
    components: {
    },
})

export default class SSOSaml extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        certificate: {
            name: 'Certificate',
            field: 'b-form-textarea',
            modelKey: 'certificate',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        entryPoint: {
            name: 'Entry Point',
            field: 'b-form-input',
            modelKey: 'entryPoint',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        identifierFormat: {
            name: 'Identifier Format',
            field: 'b-form-input',
            modelKey: 'identifierFormat',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
    };

    private responseMapperFields: any = {
        responseMapper: {
            name: 'Response Mapper',
            key: 'responseMapper',
            fields: {
                oldFields: {
                    name: 'old Label',
                    field: 'b-form-input',
                    modelKey: 'oldFields',
                    modelValue: '',
                    validate: { required: false },
                },
                newFields: {
                    name: 'new Label',
                    field: 'b-form-input',
                    modelKey: 'newFields',
                    modelValue: '',
                    validate: { required: false },
                },
            },
        },
    };
    private additionalParamsFields: any = {
        additionalParams: {
            name: 'Additional Params',
            key: 'additionalParams',
            fields: {
                oldFields: {
                    name: 'old Label',
                    field: 'b-form-input',
                    modelKey: 'oldFields',
                    modelValue: '',
                    validate: { required: false },
                },
                newFields: {
                    name: 'new Label',
                    field: 'b-form-input',
                    modelKey: 'newFields',
                    modelValue: '',
                    validate: { required: false },
                },
            },
        },
    };

    private responseMapper: any = {
        oldFields: '',
        newFields: '',
    };

    private additionalParams: any = {
        oldFields: '',
        newFields: '',
    };

    private responseMap: any = [
        { old: 'emails', new: 'mail' },
        { old: 'username', new: 'login_name' },
        { old: 'last_name', new: 'last_name' },
        { old: 'first_name', new: 'first_name' },
        { old: 'reference_id', new: 'nameID' },
    ];

    private additionalPar: any = [
        { old: 'sp', new: 'gooru.org' },
    ];

    private onAdd(addFor: any) {
        if (addFor === 'additionalParams') {
            const resp = {
                old: this.additionalParams.oldFields,
                new: this.additionalParams.newFields,
            };
            this.additionalPar.push(resp);
            this.makeFiledsEmpty(this.additionalParams);
        } else if (addFor === 'responseMapper') {
            const resp = {
                old: this.responseMapper.oldFields,
                new: this.responseMapper.newFields,
            };
            this.responseMap.push(resp);
            this.makeFiledsEmpty(this.responseMapper);
        }
    }

    private makeFiledsEmpty(obj: any) {
        obj.oldFields = '';
        obj.newFields = '';
    }

    private onDelete(deleteItem: any, deleteFor: any) {
        if (deleteFor === 'additionalParams') {
            const itemIndex = this.additionalPar.findIndex((item: any) => {
                return item.old === deleteItem.old && item.old === deleteItem.old;
            });
            if (itemIndex !== -1) {
                this.additionalPar.splice(itemIndex, 1);
            }
        } else if (deleteFor === 'responseMapper') {
            const itemIndex = this.responseMap.findIndex((item: any) => {
                return item.old === deleteItem.old && item.old === deleteItem.old;
            });
            if (itemIndex !== -1) {
                this.responseMap.splice(itemIndex, 1);
            }
        }
    }

}
